/* tslint:disable */
require('./FileTypeRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_dcca63a4',
  relative: 'relative_dcca63a4',
  fabricIcon: 'fabricIcon_dcca63a4',
  container: 'container_dcca63a4',
  folder: 'folder_dcca63a4',
};

export default styles;
/* tslint:enable */